import FormFieldViewText from "components/FormFields/ViewText";
import FormField from "ds/components/Form/Field";
import SecretFieldDetails from "ds/components/SecretFieldDetails";
import { GithubEnterpriseIntegration } from "types/generated";

import { REGENERATE_GITHUB_ENTERPRISE_INTEGRATION_WEBHOOK_SECRET } from "../../gql";
import { useRefreshSecret } from "../../useRefreshSecret";
import { VCSCheckLabels } from "./helpers";
import VCSIntegrationsUseGitCheckoutInfo from "./UseGitCheckoutInfo";

type VCSIntegrationsDetailsGitHubEnterpriseProps = {
  details: GithubEnterpriseIntegration;
  canEdit?: boolean;
};

const VCSIntegrationsDetailsGitHubEnterprise = ({
  details,
  canEdit,
}: VCSIntegrationsDetailsGitHubEnterpriseProps) => {
  const [webhookSecret, regenerateSecret] = useRefreshSecret(
    details.id,
    details.webhookSecret,
    REGENERATE_GITHUB_ENTERPRISE_INTEGRATION_WEBHOOK_SECRET,
    (data) => data.githubEnterpriseIntegrationRegenerateWebhookSecret.webhookSecret
  );

  return (
    <>
      {/* TODO: wait for API changes, the current name is integrations name not a GitHub App name */}
      <FormFieldViewText label="GitHub app name" value={details.name} />

      <FormFieldViewText label="API host URL" value={details.apiHost} />

      <FormFieldViewText label="User facing host URL" value={details.userFacingHost} />

      <FormFieldViewText label="App ID" value={details.appID} />

      <FormField label="Webhook secret">
        <SecretFieldDetails
          secret={webhookSecret}
          regenerateSecret={canEdit ? regenerateSecret : undefined}
        />
      </FormField>

      <FormFieldViewText
        label="Webhook endpoint"
        value={details.webhookUrl}
        withCopy
        noTextEllipsis
        textWordBreak
      />

      <VCSIntegrationsUseGitCheckoutInfo value={details.useGitCheckout} />

      <FormFieldViewText label="VCS checks" value={VCSCheckLabels[details.vcsChecks]} />
    </>
  );
};

export default VCSIntegrationsDetailsGitHubEnterprise;
